const fallbackUrl = "https://api.cp.devel:8443/v2";

export const client = {
    get: async (url, options = {}) => {
        const response = await fetch(`${process.env.REACT_APP_API_URL || fallbackUrl}${url}`, {
            ...options,
            method: 'GET',
        });
        return {
            status: response.status,
            data: response.ok ? await response.json() : null,
            error: !response.ok ? {
                status: response.status,
                statusText: response.statusText,
            } : null,
        }
    },
    post: async (url, data, options = {}) => {
        const response = await fetch(`${process.env.REACT_APP_API_URL || fallbackUrl}${url}`, {
            ...options,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                ...options.headers,
            },
            body: JSON.stringify(data),
        });
        
        let responseData = null;
        let errorData = null;
        
        // Try to parse JSON response for both success and error cases
        try {
            responseData = await response.json();
        } catch (jsonError) {
            // If JSON parsing fails, responseData remains null
            console.warn('Failed to parse JSON response:', jsonError);
        }
        
        if (!response.ok) {
            errorData = {
                status: response.status,
                statusText: response.statusText,
                data: responseData // Include parsed error data (for validation errors)
            };
        }
        
        return {
            status: response.status,
            data: response.ok ? responseData : null,
            error: errorData,
        }
    },
};